import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import * as graphql from '@treams/treams-network';
import { Modal, Popover } from '@treams/treams-ui';

import CompetencyLevelSetEditor from '../../evaluations/competency-level-sets/CompetencyLevelSetEditor';

export default function CompetencyLevelSetModal(props: {
	returnUrl: string;
	set?: graphql.CompetencyLevelSet;
	onSave: (set: graphql.CompetencyLevelSet) => void;
}) {
	const { t } = useTranslation();
	const history = useHistory();

	return (
		<Popover center visible>
			<Modal>
				<Modal.Header
					title={t(`common.settings.competencyLevelSets.${props.set ? 'edit' : 'create'}.title`)}
					onClose={() => history.push(props.returnUrl)}
				/>
				<CompetencyLevelSetEditor
					set={props.set}
					onSave={(set) => {
						props.onSave(set);
						history.push(props.returnUrl);
					}}
					onCancel={() => history.push(props.returnUrl)}
				/>
			</Modal>
		</Popover>
	);
}
